import React from 'react';
import { Card } from '../ui/Card';
import { Check, FileText, ListChecks, Smartphone, Wind, Thermometer, PenTool, Activity } from 'lucide-react';
export function Solution() {
  return <section className="py-12 md:py-24 px-4 bg-slate-900 relative overflow-hidden" data-id="element-150">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-indigo-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-151" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-152">
        {/* Intro */}
        <div className="text-center mb-8 md:mb-16 space-y-4 md:space-y-6" data-id="element-153">
          <span className="text-amber-500 font-medium tracking-wider text-sm uppercase" data-id="element-154">
            El Método
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-amber-50" data-id="element-155">
            Reinicio 3AM
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-156">
            Un protocolo de 12 minutos. No es magia. Es un sistema repetible
            para bajar la activación biológica.
          </p>
        </div>

        {/* The Protocol Steps */}
        <div className="grid md:grid-cols-5 gap-4 mb-10 md:mb-20" data-id="element-157">
          {[{
          icon: Thermometer,
          title: '1. Temperatura',
          desc: 'Micro-ajuste de capas'
        }, {
          icon: Wind,
          title: '2. Respiración',
          desc: 'Patrón 4-6 para calmar'
        }, {
          icon: PenTool,
          title: '3. Descarga',
          desc: '3 líneas para cortar el bucle'
        }, {
          icon: Activity,
          title: '4. Relajación',
          desc: 'Tensión muscular rápida'
        }, {
          icon: FileText,
          title: '5. Guión',
          desc: 'Regla de salida de cama'
        }].map((step, i) => <div key={i} className="flex flex-col items-center text-center p-4 rounded-xl bg-slate-800/50 border border-slate-700/50 hover:bg-slate-800 transition-colors" data-id="element-158">
              <div className="w-10 h-10 rounded-full bg-indigo-900/50 flex items-center justify-center text-indigo-300 mb-3" data-id="element-159">
                <step.icon className="w-5 h-5" data-id="element-160" />
              </div>
              <h3 className="font-semibold text-slate-200 mb-1" data-id="element-161">
                {step.title}
              </h3>
              <p className="text-xs text-slate-400" data-id="element-162">{step.desc}</p>
            </div>)}
        </div>

        {/* What's Included */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-163">
          <div className="space-y-6 md:space-y-8" data-id="element-164">
            <h3 className="text-3xl font-serif text-slate-100" data-id="element-165">
              Qué incluye <span className="text-amber-400" data-id="element-166">3AM Otra Vez</span>
            </h3>
            <p className="text-slate-400 text-lg" data-id="element-167">
              Todo diseñado para que no tengas que pensar a las 3 de la mañana.
              Solo ejecutas.
            </p>

            <ul className="space-y-6" data-id="element-168">
              <li className="flex gap-4" data-id="element-169">
                <div className="mt-1 bg-amber-500/10 p-2 rounded-lg h-fit" data-id="element-170">
                  <FileText className="w-6 h-6 text-amber-500" data-id="element-171" />
                </div>
                <div data-id="element-172">
                  <h4 className="text-lg font-semibold text-slate-200" data-id="element-173">
                    ebook Principal (Protocolo Completo)
                  </h4>
                  <p className="text-slate-400 text-sm" data-id="element-174">
                    La explicación profunda del por qué y el paso a paso
                    detallado.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-175">
                <div className="mt-1 bg-amber-500/10 p-2 rounded-lg h-fit" data-id="element-176">
                  <ListChecks className="w-6 h-6 text-amber-500" data-id="element-177" />
                </div>
                <div data-id="element-178">
                  <h4 className="text-lg font-semibold text-slate-200" data-id="element-179">
                    Workbook de 7 Noches
                  </h4>
                  <p className="text-slate-400 text-sm" data-id="element-180">
                    Para implementar el sistema sin agobiarte.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-181">
                <div className="mt-1 bg-amber-500/10 p-2 rounded-lg h-fit" data-id="element-182">
                  <Smartphone className="w-6 h-6 text-amber-500" data-id="element-183" />
                </div>
                <div data-id="element-184">
                  <h4 className="text-lg font-semibold text-slate-200" data-id="element-185">
                    Tarjeta Digital "3AM"
                  </h4>
                  <p className="text-slate-400 text-sm" data-id="element-186">
                    Una sola imagen para tu teléfono con los pasos exactos para
                    cuando abres los ojos.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div className="relative" data-id="element-187">
            <div className="absolute inset-0 bg-amber-500/20 blur-[80px] rounded-full" data-id="element-188" />
            <Card variant="highlight" className="relative transform md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-189">
              <div className="space-y-6" data-id="element-190">
                <h4 className="text-xl font-serif text-amber-100 text-center border-b border-slate-700 pb-4" data-id="element-191">
                  Lo que puede cambiar en 7 noches
                </h4>
                <ul className="space-y-4" data-id="element-192">
                  {['Menos pánico en el momento del despertar', 'Episodios más cortos y controlados', "Más noches donde logras 'volver a caer'", "La sensación de 'ya sé qué hacer' (adiós impotencia)"].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-300" data-id="element-193">
                      <Check className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-194" />
                      <span data-id="element-195">{item}</span>
                    </li>)}
                </ul>
                <div className="pt-4 text-center" data-id="element-196">
                  <p className="text-sm text-slate-500 italic" data-id="element-197">
                    No es una cura mágica. Es un plan de gestión.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}